import { InMemoryDbService } from 'angular-in-memory-web-api';
import { IconsFakeDb } from './icons';
import { RolestFakeDb } from './roles';
import { TenantsFakeDb } from './tenants';
import { UsertFakeDb } from './user';
import { UserItemsFakeDb } from './user-items';

export class FakeDbService implements InMemoryDbService {
    // tslint:disable-next-line: no-any
    createDb(): any {
        return {
            // Roles
            'roles': RolestFakeDb.roles,

            // Tenants
            'tenants': TenantsFakeDb.tenants,

            // User
            'user': UsertFakeDb.User,
            'user-items': UserItemsFakeDb.UsersItems,
        };
    }
}
